import { Sheet, SheetContent, SheetTitle, SheetDescription } from './ui/sheet';

export const ResponsiveSidebar = ({ sidebar, testid, children }) => {
  if (sidebar.mobile) return (
    <Sheet open={sidebar.open} onOpenChange={sidebar.setOpen}>
      <SheetContent side="left" className="w-72 max-w-[90vw] p-0 bg-slate-900 text-white border-slate-800 flex flex-col" data-testid={testid}>
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <SheetDescription className="sr-only">Workspace navigation</SheetDescription>
        {children}
      </SheetContent>
    </Sheet>
  );
  if (sidebar.collapsed) return null;
  return <aside className="w-64 bg-slate-900 text-white flex flex-col sticky top-0 self-start h-screen shrink-0" style={{ height: '100dvh' }} data-testid={testid}>{children}</aside>;
};